import { createContext } from "react";

const GridContext = createContext({ itemSpacing: 0 });
const GridContextProvider = GridContext.Provider;

export { GridContext, GridContextProvider };
